import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import styles from './Chart.module.scss'

const calcTotalWidth = (filteredDataset) =>
  filteredDataset.reduce(
    (acc, currentDatapoint) => acc + currentDatapoint.value,
    0
  )

const dataWithDisplayParams = (dataset, gap) => {
  const filteredDataset = dataset.filter((datapoint) => !!datapoint.value)
  const halfGap = gap / 2
  const widthTotal = calcTotalWidth(filteredDataset)

  let position = 0
  let barWidth = 0
  const bars = filteredDataset.map((datapoint, index) => {
    // Since the first and last bars only have a gap on one side of them, subtract
    // half of the gap size from their length. For all other bars, subtract the entire
    // gap size since there will be a gap on both sides and position them a full gap
    // size away from the previous bar
    const percentOfTotal = (datapoint.value * 100) / widthTotal
    if (index === 0) {
      position = 0
      barWidth = percentOfTotal - halfGap
    } else if (index === filteredDataset.length - 1) {
      position = position + barWidth + gap
      barWidth = percentOfTotal - halfGap
    } else {
      position = position + barWidth + gap
      barWidth = percentOfTotal - gap
    }

    return Object.assign(
      {
        position,
        barWidth,
        label: `${datapoint.title} ${percentOfTotal.toFixed(2)}%`,
      },
      datapoint
    )
  })

  return bars
}

const Chart = ({ data, gapPercent, className }) => {
  const bars = dataWithDisplayParams(data, gapPercent)

  return (
    <svg
      height="12"
      width="292"
      viewBox="0 0 292 12"
      className={classnames(styles.chart, className)}
    >
      {bars.map((bar, index) => (
        <rect
          key={index}
          width={`${bar.barWidth}%`}
          height="100%"
          style={{ fill: bar.color }}
          x={`${bar.position}%`}
          aria-label={bar.label}
        />
      ))}
    </svg>
  )
}

Chart.propTypes = {
  className: PropTypes.string,
  gapPercent: PropTypes.number,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.number,
      color: PropTypes.string,
      title: PropTypes.string,
    })
  ),
}

Chart.defaultProps = {
  className: '',
  gapPercent: 1,
  data: [],
}

export default Chart
